import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const declarationTypesApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'declarationTypesApi',
  endpoints: (builder) => ({
    getDeclarationTypes: builder.query<DeclarationTypeItem[], string>({
      query: (query) => `certification/v4.0/declaration_types/`,
    }),
  }),
})

export const declarationTypesSlice = createSlice({
  name: 'declarationTypes',
  initialState: {
    declarationTypes: [] as DeclarationTypeItem[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      declarationTypesApi.endpoints.getDeclarationTypes.matchFulfilled,
      (state, { payload }) => {
        state.declarationTypes = payload
      }
    );
  },
})

export const { useLazyGetDeclarationTypesQuery } = declarationTypesApi

export const useDeclarationTypes = () => {
  return useSelector(({ declarationTypes }: ReturnType<typeof rootReducer>) => declarationTypes.declarationTypes)
}
